module.exports = __webpack_public_path__ + "static/sliderplaceholder-58a79a3e79bd8d1b27bacd71a056a67c.jpg";